import { render, staticRenderFns } from "./informacao-geral.vue?vue&type=template&id=a6e15e18&scoped=true&"
import script from "./informacao-geral.vue?vue&type=script&lang=js&"
export * from "./informacao-geral.vue?vue&type=script&lang=js&"
import style0 from "./informacao-geral.vue?vue&type=style&index=0&id=a6e15e18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e15e18",
  null
  
)

export default component.exports